(() => {
  const root = document.getElementById('tgf-monster-root');
  if (!root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';

  const get = (id) => root.querySelector('#tgf-monster-' + id);
  const assistant = get('assistant');
  const edgeTab = get('edge-tab');
  const support = get('support');
  const chat = get('chat-panel');
  const monster = get('monster');
  const input = get('chat-input');
  const messages = get('chat-messages');
  const form = get('chat-form');
  const send = form.querySelector('button[type="submit"]');
  const history = [];

  const setSupport = (open) => {
    support.hidden = !open;
    if (open) chat.hidden = true;
    monster.setAttribute('aria-expanded', String(open));
  };
  const setChat = (open) => {
    chat.hidden = !open;
    if (open) {
      support.hidden = true;
      input.focus();
    }
    monster.setAttribute('aria-expanded', String(open));
  };
  const toggle = () => {
    if (!chat.hidden) setChat(false);
    else setSupport(support.hidden);
  };
  const dismiss = () => {
    setSupport(false);
    setChat(false);
    assistant.hidden = true;
    edgeTab.hidden = false;
  };
  let bubbleTimer;
  const resetBubbleTimer = () => {
    clearTimeout(bubbleTimer);
    bubbleTimer = setTimeout(() => assistant.classList.add('compact'), 12000);
  };
  resetBubbleTimer();

  monster.addEventListener('click', toggle);
  get('bubble-open').addEventListener('click', toggle);
  get('support-close').addEventListener('click', () => setSupport(false));
  get('chat-back').addEventListener('click', () => setSupport(true));
  get('chat-close').addEventListener('click', () => setChat(false));
  get('dismiss').addEventListener('click', dismiss);
  get('dismiss-mini').addEventListener('click', dismiss);
  edgeTab.addEventListener('click', () => {
    edgeTab.hidden = true;
    assistant.hidden = false;
    assistant.classList.remove('compact');
    resetBubbleTimer();
    setSupport(true);
  });
  get('assistant-choice').addEventListener('click', () => setChat(true));
  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setSupport(false);
      setChat(false);
    }
  });

  const appendMessage = (message, isUser = false, data = {}) => {
    const item = document.createElement('div');
    item.className = 'chat-message' + (isUser ? ' is-user' : '');
    item.textContent = message;
    const links = [
      ...(Array.isArray(data.products) ? data.products : []),
      ...(data.handoff ? [data.handoff] : []),
    ];
    for (const link of links) {
      try {
        const url = new URL(link.url);
        if (url.protocol !== 'https:' || !['tagsforever.com', 'www.tagsforever.com', 'wa.me'].includes(url.hostname)) continue;
        const anchor = document.createElement('a');
        anchor.href = url.href;
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        anchor.textContent = link.title || link.label || 'Bağlantıyı aç';
        item.appendChild(anchor);
      } catch (_) {
        continue;
      }
    }
    messages.appendChild(item);
    messages.scrollTop = messages.scrollHeight;
    return item;
  };

  const containsPersonalData = (message) =>
    /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}|(?<!\d)(?:\+?90|0)?[\s-]?5\d{2}(?:[\s-]?\d){7}(?!\d)|(?<!\d)\d{10,15}(?!\d)|(?<!\w)#\s*\d{4,}(?!\d)|\b(?:adım|soyadım|ismim|adresim)\s+\p{L}+/iu.test(message);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const message = input.value.trim();
    if (!message || send.disabled) return;
    if (containsPersonalData(message)) {
      appendMessage('Kişisel bilgilerini bu sohbete yazma. Kargo için Elif’e, diğer konular için Olcayto’ya WhatsApp üzerinden ulaşabilirsin.');
      input.value = '';
      return;
    }
    const prior = history.slice(-4);
    appendMessage(message, true);
    input.value = '';
    send.disabled = true;
    const pending = appendMessage('Yanıt hazırlanıyor…');
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 70000);
    try {
      const response = await fetch('https://tgfhub.com/storefront/assistant/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({ message, history: prior }),
        signal: controller.signal,
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Asistan yanıt veremiyor.');
      const reply = String(data.reply || 'Şu anda yanıt veremiyorum.').replaceAll('**', '');
      pending.remove();
      appendMessage(reply, false, data);
      history.push({ role: 'user', content: message }, { role: 'assistant', content: reply });
    } catch (_) {
      pending.textContent = 'Şu anda gerçek asistana ulaşılamıyor. Kargo için Elif’e, ürünlerle ilgili konular için Olcayto’ya yazabilirsin.';
    } finally {
      clearTimeout(timer);
      send.disabled = false;
      input.focus();
    }
  });

  root.querySelectorAll('[data-example]').forEach((button) => button.addEventListener('click', () => {
    input.value = button.dataset.example || '';
    form.requestSubmit();
  }));
})();
